import { render, staticRenderFns } from "./behavior-list.vue?vue&type=template&id=6a8c7648&scoped=true&"
import script from "./behavior-list.vue?vue&type=script&lang=js&"
export * from "./behavior-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8c7648",
  null
  
)

export default component.exports